import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-add_member",
  "use": "icon-add_member-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-add_member\"><path d=\"M880.3 713h-104V609c0-17.6-14.4-32-32-32s-32 14.4-32 32v104h-104c-17.6 0-32 14.4-32 32s14.4 32 32 32h104v104c0 17.6 14.4 32 32 32s32-14.4 32-32V777h104c17.6 0 32-14.4 32-32s-14.4-32-32-32zM504.4 113.1c-122.3 4-221.6 104.6-224.1 227-1.7 80.9 38.1 152.6 99.5 195.4-145.3 51-252.3 183.4-266.1 342.6-1.6 18.8 13 35 31.9 35 16.8 0 30.4-12.9 31.9-29.6 15-170.5 157.8-304.8 331.7-306.4 128.5-1.1 235.1-103.7 235-232.2 0-130.8-108.1-236.1-239.8-231.8z m7.9 399.9c-92.6 0-168-75.4-168-168s75.4-168 168-168 168 75.4 168 168-75.4 168-168 168z\" p-id=\"9695\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/chat/add_member.svg
// module id = mb3d
// module chunks = 24